"use strict";
exports.__esModule = true;
require("./theme.scss");
var CLASS = {
    HEADER_BBS: 'p-header--bbs',
    HEADER_YUE: 'p-header--yue',
    HEADER_GODSONG: 'p-header--shenqu',
    HEADER_SV: 'p-header--sv',
    HEADER_FIXED: 'p-header--fixed',
    HEADER_WITHOUT_SEARCH: 'p-header--without-search',
    HEADER_WITH_BACK: 'p-header--with-back',
    HEADER_WITH_HISTORY: 'p-header--with-history',
    HEADER_BACK_HIGH_LIGHT: 'p-header--back-hl',
    HEADER_CATALOG_HIGH_LIGHT: 'p-header--catalog-hl'
};
var DOMAIN = window.location.protocol + "//www.yy.com";
exports.DOMAIN = DOMAIN;
if (location.hostname === 'yy.duowan.com') {
    exports.DOMAIN = DOMAIN = window.location.protocol + "//yy.duowan.com";
}
var IS_DEV = process.env.mode !== 'master';
exports.IS_DEV = IS_DEV;
var DEFAULT_AVATAR = require('../../../images/default_portrait.jpg');
exports.DEFAULT_AVATAR = DEFAULT_AVATAR;
var SETTING = {
    download: {
        inPromotion: false,
        flink: {
            title: '下载追看视频',
            sub: '登录立拆7元红包',
            qrcode: require('./images/2wm-flink.png'),
            link: 'https://android.myapp.com/myapp/detail.htm?apkName=com.yy.yylite&ADTAG=mobile'
        },
        mobileYY: {
            title: 'IOS下载手机YY',
            sub: '语音直播不卡顿',
            qrcode: require('./images/2wn-head.png'),
            link: 'http://www.yy.com/download'
        }
    },
    header: {
        downloadGuide: {
            enable: true,
            tips: '领红包'
        }
    },
    yyBear: {
        defaultTips: '领红包'
    }
};
var EHeaderOptsCurrent;
(function (EHeaderOptsCurrent) {
    EHeaderOptsCurrent["INDEX"] = "index";
    EHeaderOptsCurrent["CATALOG"] = "catalog";
})(EHeaderOptsCurrent || (EHeaderOptsCurrent = {}));
exports.EHeaderOptsCurrent = EHeaderOptsCurrent;
var EHeaderOptsType;
(function (EHeaderOptsType) {
    EHeaderOptsType["YY"] = "yy";
    EHeaderOptsType["YUE"] = "yue";
    EHeaderOptsType["SHENQU"] = "shenqu";
    EHeaderOptsType["BBS"] = "bbs";
    EHeaderOptsType["SV"] = "sv";
})(EHeaderOptsType || (EHeaderOptsType = {}));
exports.EHeaderOptsType = EHeaderOptsType;
function theme(op) {
    if (op === void 0) { op = {}; }
    var headerClasses = [];
    var homePage = DOMAIN;
    var searchMeta;
    switch (op.type) {
        case 'yue':
            headerClasses.push(CLASS.HEADER_YUE);
            homePage = '//www.yy.com/yue';
            searchMeta = {
                searchTypeName: 'searchType',
                current: 1,
                action: '//www.yy.com/yue/search',
                keywordName: 'keywords',
                opts: [
                    { text: '媒体', value: 0 },
                    { text: '新闻', value: 1 },
                    { text: '直播', value: -1 }
                ]
            };
            break;
        case 'bbs':
            headerClasses.push(CLASS.HEADER_BBS);
            headerClasses.push(CLASS.HEADER_WITHOUT_SEARCH);
            homePage = '//www.yy.com/bbs';
            break;
        case 'shenqu':
            headerClasses.push(CLASS.HEADER_GODSONG);
            homePage = '//www.yy.com/shenqu';
            break;
        case 'sv':
            headerClasses.push(CLASS.HEADER_SV);
            homePage = '//www.yy.com/sv';
            break;
        default:
            headerClasses.push(CLASS.HEADER_WITH_HISTORY);
            break;
    }
    if (op.ignoreSearch) {
        headerClasses.push(CLASS.HEADER_WITHOUT_SEARCH);
    }
    if (op.fixed) {
        headerClasses.push(CLASS.HEADER_FIXED);
    }
    if (op.current) {
        if (op.current === EHeaderOptsCurrent.INDEX) {
            headerClasses.push(CLASS.HEADER_BACK_HIGH_LIGHT);
        }
        else if (op.current === EHeaderOptsCurrent.CATALOG) {
            headerClasses.push(CLASS.HEADER_CATALOG_HIGH_LIGHT);
        }
    }
    else {
        var pos = window.pageInfo && window.pageInfo.position;
        switch (pos) {
            case 'studio':
            case 'play':
            case 'secondary':
                headerClasses.push(CLASS.HEADER_WITH_BACK);
                break;
            default:
                break;
        }
    }
    return Object.assign(op, {
        headerClasses: headerClasses,
        homePage: homePage,
        searchMeta: searchMeta,
        setting: SETTING
    });
}
exports.theme = theme;
